import { isSSR } from "@website/utils/is-ssr";

export const getOrigin = () =>
  isSSR()
    ? process.env.ORIGIN || "https://www.snapptrip.com"
    : window.location.origin;
